import React, {Component} from "react";
import Navigator from "../../components/Navigator";
import Footer from "../../components/Footer";
import {profile} from "../../store/actions/userActions";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";

class Master extends Component {


    componentDidMount() {
        let isActive = window.localStorage.getItem("isActive");
        // isActive = isActive ? JSON.parse(isActive) : null;

        let token = window.localStorage.getItem("access_token");

        token = token ? JSON.parse(token) : null;


        if (token) {
            this.props.profile();
        }

    }


    render() {

        const children = React.Children.map(this.props.children, (child, index) => {
            return React.cloneElement(child, {
                authUser: this.props.authUser,
            });
        });

        return (


            <div className="default-layout">
                <Navigator mobileMenuIsShown={this.props.mobileMenuIsShown} authUser={this.props.authUser}/>
                {children}
                <Footer/>
            </div>
        )
    }
}


const mapStateToProps = (state) => {
    return {
        authUser: state.user.authUser,
    }

};

const mapDispatchToProps = (dispatch) => {
    return {
        profile: () => dispatch(profile()),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Master))
